import React, { useState } from 'react';
import './index.css';

function App() {
  const [nomes, setNomes] = useState('');
  const [resultado, setResultado] = useState('');
  const [sorteando, setSorteando] = useState(false);

  const sortear = () => {
    const lista = nomes.split('\n').filter(nome => nome.trim() !== '');
    
    if (lista.length > 0) {
      setSorteando(true);
      
      let contador = 0;
      const maxVezes = 15;
      const intervalo = setInterval(() => {
        const indiceAleatorio = Math.floor(Math.random() * lista.length);
        setResultado(lista[indiceAleatorio]);
        contador++;

        if (contador >= maxVezes) {
          clearInterval(intervalo);
          setSorteando(false);
        }
      }, 60);
    }
  };

  return (
    <div className="app">
      {/* Header Centralizado */}
      <header className="header-centralizado">
        <div className="container">
          <div className="header-content-center">
            <img src="/drlucas.jpg" alt="Dr. Lucas Ribeiro" className="header-foto" />
            <div className="header-textos">
              <h1 className="header-nome">Dr. Lucas Ribeiro</h1>
              <p className="header-crm">CRM-MG 38226 · RQE 14684 · 42397</p>
            </div>
          </div>
        </div>
      </header>

      <main className="main">
        <div className="container">
          <div className="card">
            {/* Header do card */}
            <div className="card-header">
              <h2>Sorteio</h2>
              <p className="subtitulo">
                Ferramenta validada para um sorteio justo
              </p>
            </div>

            {/* Área da lista */}
            <div className="input-area">
              <div className="label-group">
                <span className="label-icon">📋</span>
                <label className="label">LISTA DE PARTICIPANTES (um por linha)</label>
              </div>
              
              <div className="textarea-wrapper">
                <textarea
                  value={nomes}
                  onChange={(e) => setNomes(e.target.value)}
                  placeholder="João Silva&#10;Maria Oliveira&#10;Pedro Santos&#10;Ana Costa"
                  className="textarea-moderna"
                />
              </div>

              <div className="stats-container">
                <div className="stat-item">
                  <span className="stat-valor">{nomes.split('\n').filter(n => n.trim()).length}</span>
                  <span className="stat-label">Participantes</span>
                </div>
                <div className="stat-item">
                  <span className="stat-valor">{resultado ? '1' : '0'}</span>
                  <span className="stat-label">Selecionado</span>
                </div>
                <div className="stat-item">
                  <span className="stat-valor">Aleatorização</span>
                  <span className="stat-label">Justa</span>
                </div>
              </div>
            </div>

            {/* Botão de sorteio */}
            <button 
              onClick={sortear} 
              className={`btn-sortear ${sorteando ? 'sorteando' : ''}`}
              disabled={!nomes.trim() || sorteando}
            >
              <span className="btn-content">
                {sorteando ? (
                  <>
                    <span className="spinner"></span>
                    SORTEANDO...
                  </>
                ) : (
                  <>
                    <span className="icone">🎲</span>
                    REALIZAR SORTEIO
                  </>
                )}
              </span>
            </button>

            {/* Resultado */}
            {resultado && (
              <div className="resultado">
                <div className="resultado-header">
                  <div className="resultado-tag">Nome sorteado</div>
                </div>

                <div className="resultado-corpo">
                  <div className="nome-sorteado-container">
                    <span className="nome-sorteado">{resultado}</span>
                  </div>

                  <div className="assinatura-medica">
                    <img src="/drlucas.jpg" alt="Dr. Lucas" className="assinatura-foto" />
                    <div className="assinatura-texto">
                      <p className="nome-assinatura">Dr. Lucas Ribeiro</p>
                      <p className="crm-assinatura">CRM-MG 38226 | RQE 14684 · 42397</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Info complementar */}
            <div className="info-complementar">
              <h3>⚕️ Sobre esta ferramenta</h3>
              <p>Desenvolvida para garantir imparcialidade em seleções.</p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col">
              <h4>Dr. Lucas Ribeiro</h4>
              <p>Endocrinologia · Ginecologia · Metabologia</p>
              <p className="crm-footer">CRM-MG 38226 · RQE 14684 · 42397</p>
            </div>
            
            <div className="footer-col">
              <h4>Atendimento</h4>
              <p>Lavras · Nepomuceno · Perdões · BH</p>
              <p>Segunda à Sexta: 8h às 18h</p>
            </div>
            
            <div className="footer-col">
              <h4>Contato</h4>
              <p>contato@drlucasribeiro.com.br</p>
              <p>+55 35 8854-7666</p>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>© 2026 Dr. Lucas Ribeiro · Todos os direitos reservados</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;